import Vue from "vue";

import "@/assets/css/theme/index.css";
// import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";

import rrjutils from "./utils/rrjutils";
Vue.use(rrjutils);

import Clipboard from "v-clipboard";
Vue.use(Clipboard);

import GLOBAL from "./global";
Vue.prototype.$global = GLOBAL;

import "@/permission"; // permission control
import "@/assets/css/base.scss"; // permission control

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.use(ElementUI);

Vue.config.productionTip = false;

import md5 from "js-md5";
Vue.prototype.$md5 = md5;

new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
}).$mount("#app");

import ConditionInput from "@/components/form/condition-input.vue";
Vue.component("condition-input", ConditionInput);

import ConditionTimerange from "@/components/form/condition-timerange.vue";
Vue.component("condition-timerange", ConditionTimerange);

import ConditionSelect from "@/components/form/condition-select.vue";
Vue.component("condition-select", ConditionSelect);

import PreviewQrcode from "@/components/form/preview-qrcode.vue";
Vue.component("preview-qrcode", PreviewQrcode);

// 选择公共资源组件
import SourcePictureSelector from "@/components/source/SourcePictureSelector.vue";
Vue.component("source-picture-selector", SourcePictureSelector);
import SourceSelector from "@/components/source/SourceSelector.vue";
Vue.component("source-selector", SourceSelector);

Number.prototype.numberToCurrency = function () {
  if (!this) return "";
  // 获取整数部分
  const intPart = Math.trunc(this);
  // 整数部分处理，增加,
  const intPartFormat = intPart
    .toString()
    .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  // 预定义小数部分
  let floatPart = "";
  // 将数值截取为小数部分和整数部分
  const valueArray = this.toString().split(".");
  if (valueArray.length === 2) {
    // 有小数部分
    floatPart = valueArray[1].toString(); // 取得小数部分
    return intPartFormat + "." + floatPart;
  }
  return intPartFormat + floatPart;
};

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

import { formatDateTime } from "@/utils/index";

// 全局注册一个日期格式化过滤器
Vue.filter("formatDateTime", function (d, s) {
  if (!d) return "-";
  return formatDateTime(d, s);
});

Vue.filter("avatarFilter", function (user) {
  if (user && user.avatar_url && user.avatar_url.startsWith("http")) {
    return user.avatar_url.replace(
      "https://renrenjiang-stage.oss-cn-hangzhou.aliyuncs.com",
      "https://image.renrenjiang.cn"
    );
  } else if (user && user.avatar && user.avatar.startsWith("http")) {
    return user.avatar.replace(
      "https://renrenjiang-stage.oss-cn-hangzhou.aliyuncs.com",
      "https://image.renrenjiang.cn"
    );
  } else if (user && user.avatar_url) {
    return `https://image.renrenjiang.cn/uploads/user/avatar_url/${user.id}/${user.avatar_url}`;
  } else {
    return "https://image.renrenjiang.cn/assets/avatar_jy.jpg";
  }
});

Vue.prototype.base64ToFile = function (dataurl, filename = "file") {
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  // suffix是该文件的后缀
  let suffix = mime.split("/")[1];
  // atob 对经过 base-64 编码的字符串进行解码
  let bstr = atob(arr[1]);
  // n 是解码后的长度
  let n = bstr.length;
  // Uint8Array 数组类型表示一个 8 位无符号整型数组 初始值都是 数子0
  let u8arr = new Uint8Array(n);
  // charCodeAt() 方法可返回指定位置的字符的 Unicode 编码。这个返回值是 0 - 65535 之间的整数
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  // new File返回File对象 第一个参数是 ArraryBuffer 或 Bolb 或Arrary 第二个参数是文件名
  // 第三个参数是 要放到文件中的内容的 MIME 类型
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime,
  });
};

Vue.prototype.getFileBase64 = async function (file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    let fileResult = "";
    reader.readAsDataURL(file);
    //开始转
    reader.onload = function () {
      fileResult = reader.result;
    };
    //转 失败
    reader.onerror = function (error) {
      reject(error);
    };
    //转 结束  咱就 resolve 出去
    reader.onloadend = function () {
      resolve(fileResult);
    };
  });
};

Vue.prototype.getRemoteImageBase64 = async function (url) {
  return new Promise((resolve, reject) => {
    // 创建一个新的XMLHttpRequest对象
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob"; // 设置响应类型为blob

    xhr.onload = () => {
      if (this.status === 200) {
        // 创建一个FileReader对象
        const reader = new FileReader();
        reader.onload = function (event) {
          // 读取完成，event.target.result为base64编码的字符串
          const base64String = event.target.result;
          console.log(base64String); // 输出base64编码的字符串
          resolve(base64String);
        };
        reader.readAsDataURL(xhr.response); // 读取Blob对象为DataURL（base64编码）
      } else {
        console.error("Error loading the image:", this.statusText);
      }
    };
    xhr.onerror = () => {
      reject("failed");
      console.error("There was a network error.");
    };
    xhr.send();
  });
};

/**
 * @param {Object} str 需要脱敏的字符串
 * @param {Object} begin 前面保留位数
 * @param {Object} end 后面保留位数
 */
Vue.prototype.desensitized = function (str, begin, end) {
  if (!str && begin + end >= str.length) {
    return "";
  }

  let leftStr = str.substring(0, begin);
  let rightStr = str.substring(str.length - end, str.length);

  let strCon = "";
  for (let i = 0; i < str.length - end - begin; i++) {
    strCon += "*";
  }
  return leftStr + strCon + rightStr;
};

/**
 * 获取两个日期相差天数
 * @param {*} date_1
 * @param {*} date_2
 * @returns
 */
Vue.prototype.getDifferDay = function (date_1, date_2) {
  let totalDays, diffDate;
  let myDate_1 = Date.parse(date_1);
  let myDate_2 = Date.parse(date_2);
  diffDate = Math.abs(myDate_1 - myDate_2);
  totalDays = Math.floor(diffDate / (1000 * 3600 * 24));
  return totalDays;
};

/**
 * 字节数格式化
 * @returns
 */
// Number.prototype.formatsize = function () {
//   if (this === null || this === 0) return "0 B";
//   const k = 1024;
//   const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
//   const i = Math.floor(Math.log(this) / Math.log(k));
//   return (this / Math.pow(k, i)).toPrecision(3) + " " + sizes[i];
// };

Number.prototype.formatsize = function () {
  if (this == null || this === 0) return "0 B";

  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  let i = 0;

  let abs = Math.abs(this);
  while (abs >= k && i < sizes.length - 1) {
    if (abs < k * 0.5) break;
    abs /= k;
    i++;
  }

  let value = (this < 0 ? -1 : 1) * abs;

  // 格式化：整数去小数，小数保留最多2位
  let str =
    Math.abs(value % 1) < 1e-6
      ? value.toFixed(0)
      : parseFloat(value.toFixed(2));

  return str + " " + sizes[i];
};

Array.prototype.swap = function (index1, index2) {
  this[index1] = this.splice(index2, 1, this[index1])[0];
  return this;
};

/**
 * 生成UUID
 */
Vue.prototype.uuid = function () {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "";

  var uuid = s.join("");
  return uuid;
};

File.prototype.getBlob = async function () {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsArrayBuffer(this);
    reader.onload = (e) => {
      let data;
      if (typeof e.target.result === "object") {
        data = window.URL.createObjectURL(new Blob([e.target.result]));
      } else {
        data = e.target.result;
      }
      resolve(data);
      // this.imgBlob = data;
      // console.log(this.imgBlob);
    };
  });
};

Vue.prototype.getImageSize = function (imagePath) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      const width = img.naturalWidth;
      const height = img.naturalHeight;
      resolve({ width, height });
    };
    img.onerror = function () {
      resolve({ width: 0, height: 0 });
    };
    img.src = imagePath;
  });
};

Vue.directive("onceClick", {
  inserted(el, binding) {
    let timer = null;
    const delay = binding.arg || 2000; // 参数: v-click-once:3000
    const { value } = binding; // 获取绑定的函数

    if (typeof value !== "function") {
      console.error("v-reclick 必须绑定一个函数");
      return;
    }

    el.addEventListener("click", async function () {
      if (timer || el.disabled) return;

      el.disabled = true;

      try {
        // 执行传递的函数
        await value.apply(this, arguments);
      } catch (error) {
        console.error("点击函数执行出错:", error);
      } finally {
        // 重置状态
        timer = setTimeout(() => {
          el.disabled = false;
          timer = null;
        }, delay);
      }
    });
  },

  unbind(el) {
    clearTimeout(el.__clickOnceTimer__);
    el.disabled = false;
  },
});
